import React, { Component, createRef } from "react";
import { MTools } from "@/components";
import { getBbsList } from "@/services/api";
import styles from "./index.less";
import BetterScroll from "@better-scroll/core";
import PullUp from "@better-scroll/pull-up";
import moment from 'moment';
import classnames from 'classnames';
import { RouteComponentProps, withRouter } from "dva/router";
import ico from "@/assets/image/ico.png";
import playing from "@/assets/image/playing.png";

interface WonderfulActivitiesProps {}
interface WonderfulActivitiesState {
  list: any[];
  loading: boolean;
  hasMore: boolean;

  tabIndex: any;
  typeData: any[];
  topicId: string | null;
}

type CloudClassroomDetailInfo = WonderfulActivitiesProps & RouteComponentProps;

BetterScroll.use(PullUp);

class WonderfulActivities extends Component<
  CloudClassroomDetailInfo,
  WonderfulActivitiesState
> {
  indexRef: any;
  bs: any;
  el: any;

  constructor(props: CloudClassroomDetailInfo) {
    super(props);
    this.state = {
      list: [],
      loading: false,
      hasMore: true,

      tabIndex: 1,
      typeData: [
        {
          title: "网络安全技术高峰论坛",
          id: 1,
        },
        {
          title: "网络安全教育云课堂",
          id: 2,
        },
        {
          title: "微视频大赛",
          id: 3,
        },
      ],
      topicId: null,
    };
    this.indexRef = createRef();
    this.el = createRef();
  }

  componentDidMount() {
    this.getBbsList();
  }

    // 获取专题视频详情
    getBbsList = async () => {
      if (!this.state.hasMore) return;
      this.setState({
        loading: true,
      });

      const result = await getBbsList("");
      if (result.success) {
        this.setState(
          {
            list: result.data,
          }
        );
      } else {
        MTools.Tips(
          "error",
          (result && result.message) || "系统异常，请刷新再试"
        );
      }

      this.setState({
        loading: false,
      });
    };

  onTabs = (i: number) => {
    this.setState({
      tabIndex: i,
    });
    if (i === 2) {
      this.props.history.push("/app/cloudClassroom");
    } else if(i === 3){
        window.open('http://m-competition.gjwlaqxcz.cn/app/home')
    }
  };

  getEL = (video: any) => {
    this.el.current = video;
  };

  // 点击跳转视频
  onhref = (todoId: any, id: string) => {
    //如果点击跳转的视频为正在播放的视频页则不跳转
    if (todoId !== id) {
      this.props.history.push(`/app/ForumDetail/${id}`);
      window.location.reload();
    }
  };

  render() {
    const { list, typeData, tabIndex } = this.state;
    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <div className={styles.wrap_center}>
          <div className={styles.title}>
            <img src={ico} alt="" />
            <span>精彩活动</span>
          </div>
          <ul className={styles.tabs}>
            {typeData.map((item, i) => {
              return (
                <li
                  onClick={() => this.onTabs(item.id)}
                  key={i}
                  className={item.id === 1 ? styles.active : ""}
                >
                  {item.title}
                </li>
              );
            })}
          </ul>
          <div className={styles.content}>
            {list.map((item: any, i: any) => {
              return (
                <div
                  key={i}
                  className={styles.card}
                  onClick={() => this.onhref(Id, item.id)}
                >
                  <div className={styles.card_img}>
                    <img src={item.cover} alt="" />
                  </div>
                  <div className={styles.card_title}>
                    <div className={styles.card_title_text}>
                      <div
                        className={classnames(
                          styles.paly_title,
                          item.id !== Id ? styles.fullWidth : null
                        )}
                      >
                        {item.title}
                      </div>
                      {
                        item.id === Id ? (
                          <img className={styles.playing} src={playing} alt="" />
                        ) : null
                      }
                    </div>
                    <div className={styles.card_time}>{moment(item.startTime).format('YYYY年M月D日 HH:mm')}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(WonderfulActivities);
